import { render } from "./Sidebar.vue?vue&type=template&id=5b0af9dc&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=5b0af9dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b0af9dc"

export default script